import {
    APPLICATION_ASSIGN,
    APPLICATION_ASSIGN_SUCCESS,
    APPLICATION_CALLNUMBER,
    APPLICATION_CALLNUMBER_FAILED,
    APPLICATION_CALLNUMBER_SUCCESS,
    APPLICATION_HIDE_ASSIGN_MODAL,
    APPLICATION_HIDE_CALLNUMBER_MODAL,
    APPLICATION_HIDE_MODAL,
    APPLICATION_LIST_FAILED,
    APPLICATION_LIST_LOADDATA,
    APPLICATION_LIST_LOADING,
    APPLICATION_LIST_SUCCESS,
    APPLICATION_MODAL_ASSIGN_LOADING,
    APPLICATION_MODAL_CALLNUMBER_LOADING,
    APPLICATION_MODAL_LOADING,
    APPLICATION_SHOW_ASSIGN_MODAL,
    APPLICATION_SHOW_CALLNUMBER_MODAL,
    APPLICATION_SHOW_MODAL,
    APPLICATION_STAGE_LOADDATA,
    APPLICATION_STAGE_SUCCESS,
    APPLICATION_STATUS_CHANGE,
    APPLICATION_STATUS_SUCCESS
} from "../constants/ApplicationlistConst";



const initState = {
    loading: false,
    message: '',
    cnmessage: '',
    showMessage: false,
    showCNessage: false,
    stages_loading: false,
    status_loading: false,
    assign_loading: false,
    callnumber_loading: false,
    modal: false,
    modal_assign: false,
    modal_callnumber: false,
    modal_loading: false,
    modal_assign_loading: false,
    modal_callnumber_loading: false,
    page: 1,
    selected: 0,
    total: 0,
    data: [],
    stages: [],
}

const productlistreducer = (state = initState, action) => {
    switch (action.type) {
        case APPLICATION_LIST_LOADING:
            return {
                ...state,
                loading: true,
            }
        case APPLICATION_LIST_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case APPLICATION_LIST_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                total:action.total,
                loading: false
            }
        case APPLICATION_LIST_LOADDATA:
            return {
                ...state,
                page:action.page,
                loading: true,
            }
        case APPLICATION_HIDE_MODAL:
            return {
                ...state,
                modal: false,
                selected: 0,
            }
        case APPLICATION_SHOW_MODAL:
            return {
                ...state,
                modal: true,
                selected: action.id,
            }
        case APPLICATION_MODAL_LOADING:
            return {
                ...state,
                modal_loading: true,
            }
        case APPLICATION_STAGE_LOADDATA:
            return {
                ...state,
                id:action.id,
                stages_loading: true,
            }
        case APPLICATION_STAGE_SUCCESS:
            return {
                ...state,
                showMessage: false,
                stages:action.data,
                stages_loading: false
            }
        case APPLICATION_STATUS_CHANGE:
            return {
                ...state,
                showMessage: false,
                id:action.id,
                status:action.status,
                status_loading: true
            }
        case APPLICATION_STATUS_SUCCESS:
            return {
                ...state,
                showMessage: false,
                status_loading: false,
                modal_loading: false,
                modal: false,
            }

        // ASIGN
        case APPLICATION_ASSIGN:
            return {
                ...state,
                showMessage: false,
                id:action.id,
                depo_id:action.depo_id,
                branch_id:action.branch_id,
                assign_loading: true
            }
        case APPLICATION_ASSIGN_SUCCESS:
            return {
                ...state,
                showMessage: false,
                assign_loading: false,
                modal_assign_loading: false,
                modal_assign: false,
            }
        case APPLICATION_SHOW_ASSIGN_MODAL:
            return {
                ...state,
                modal_assign: true,
                selected: action.id,
            }
        case APPLICATION_HIDE_ASSIGN_MODAL:
            return {
                ...state,
                modal_assign: false,
                selected: 0,
            }
        case APPLICATION_MODAL_ASSIGN_LOADING:
            return {
                ...state,
                modal_assign_loading: true,
            }
        // ASIGN


        case APPLICATION_CALLNUMBER:
            return {
                ...state,
                showCNMessage: false,
                id:action.id,
                depo_id:action.depo_id,
                branch_id:action.branch_id,
                modal_callnumber_loading: true
            }
        case APPLICATION_CALLNUMBER_SUCCESS:
            return {
                ...state,
                showCNMessage: false,
                assign_loading: false,
                modal_callnumber_loading: false,
                modal_callnumber: false,
            }
        case APPLICATION_CALLNUMBER_FAILED:
            return {
                ...state,
                cnmessage: action.message,
                showCNMessage: true,
                modal_callnumber_loading: false
            }
        case APPLICATION_SHOW_CALLNUMBER_MODAL:
            return {
                ...state,
                modal_callnumber: true,
                selected: action.id,
            }
        case APPLICATION_HIDE_CALLNUMBER_MODAL:
            return {
                ...state,
                modal_callnumber: false,
                selected: 0,
            }
        case APPLICATION_MODAL_CALLNUMBER_LOADING:
            return {
                ...state,
                modal_callnumber_loading: true,
            }
        default:
            return state;
    }
}

export default productlistreducer